import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "../trpc";
import { getQueryKey } from "@trpc/react-query";

export function useActivateTeamsTrial() {
  const queryClient = useQueryClient();
  const { mutate: activateTeamsTrial, ...rest } =
    trpc.account.activateTeamsTrial.useMutation({
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: getQueryKey(trpc.account.account, undefined, "any"),
        });
        queryClient.invalidateQueries({
          queryKey: getQueryKey(trpc.account.entitlements, undefined, "any"),
        });
        queryClient.invalidateQueries({
          queryKey: getQueryKey(trpc.user.user, undefined, "any"),
        });
      },
    });
  return { activateTeamsTrial, ...rest };
}
